import {NgModule} from '@angular/core';
import {IconComponent} from './icon.component';
import {TISA_ICON_PROVIDERS} from './icon.providers';

@NgModule({
  declarations: [IconComponent],
  exports: [IconComponent],
  providers: TISA_ICON_PROVIDERS,
})
export class IconModule {}
